import { ReactNode } from 'react';

import styles from './description-list.module.css';

type DescriptionListProps = {
  list: { label?: ReactNode; value?: ReactNode }[];
};

export const TicketDescriptionList = ({ list }: DescriptionListProps) => (
  <dl className={styles.container}>
    {list.map((item = {}, idx) => (
      <div className={styles.wrapper} key={idx}>
        <dd className={styles.label}>{item.label || ''}</dd>
        <dt className={styles.value}>{item.value || ''}</dt>
      </div>
    ))}
  </dl>
);
